import { Overlay } from "@albelli/image-list-view"

export function makeRemoveFromSelectionOverlay(removeFromSelection: (item: any) => void): Overlay {
  return (item: any, img: HTMLElement) => {
    const remove = document.createElement("i")
    remove.className = "photoselector-remove-from-selection-icon"
    remove.setAttribute("data-tam", "remove-from-selection-icon")
    remove.addEventListener("click", () => {
      removeFromSelection(item)
    })

    img.appendChild(remove)

    return () => {
      if (remove.parentNode === img) {
        img.removeChild(remove)
      }
    }
  }
}
export default makeRemoveFromSelectionOverlay
